module.exports = __webpack_public_path__ + "img/csr_121222_B.6fd42153.jpg";